// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__KO8Ts","greeting-text":"MainPage_greeting-text__wMNuy","content-wrapper":"MainPage_content-wrapper__I5fuh"};